import React from 'react';
import styled from 'styled-components';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { colors } from './Styles';

/**
 * Holy Grail Layout
 * https://philipwalton.github.io/solved-by-flexbox/demos/holy-grail/
 */
export const DashboardWrapper: React.FC<{}> = ({ children }) => {
  return (
    <Container>
      <Header />
      <Body>
        <Content>{children}</Content>
        <Sidebar />
      </Body>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
`;

const Body = styled.div`
  display: flex;
  flex: 1;
`;

const Content = styled.main`
  flex: 1;
  padding: 22px 32px;
  background: ${colors.background};
`;
